// extracted by mini-css-extract-plugin
export default {"list03":"index_list03_O4dQZ","pictxt":"index_pictxt_gQMXN","pic":"index_pic_sOFuz","txt":"index_txt_X5XbP","b_qian":"index_b_qian_v4FmB","trans":"index_trans_xuX0R"};